import { Grid } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import React from "react";

import { JoinSubscriptionPaymentView } from "@/features/subscription/components/joinSubscriptionDialog/JoinSubscriptionPaymentView";
import { JoinSubscriptionSummaryView } from "@/features/subscription/components/joinSubscriptionDialog/JoinSubscriptionSummaryView";
import { SubscriptionPlanCard } from "@/features/subscriptionPlan/components/card/SubscriptionPlanCard";
import { SubscriptionPlanFullFragment } from "@/generated/generated-hooks";

// TODO: make this component obsolete
type SubscriptionPlansDialogSubscribeMenuProps = {
  postId?: string;
  postMonth?: string;
  canUnlockPost: boolean;
  subscriptionPlan: SubscriptionPlanFullFragment;
  onClickBackToMain: () => void;
};

export const SubscriptionPlansDialogSubscribeMenu: React.FC<SubscriptionPlansDialogSubscribeMenuProps> =
  ({
    subscriptionPlan,
    onClickBackToMain,
    canUnlockPost,
    postId,
    postMonth,
  }) => {
    const { title, currency, price, _id } = subscriptionPlan;
    const isUnlockExpiredPost = !!postMonth;

    const summaryTitle = isUnlockExpiredPost
      ? `${title} (${postMonth})`
      : title;
    return (
      <Grid container wrap="wrap-reverse">
        <Grid item xs={12} md={8}>
          {/*  payment information */}
          <div className="w-full flex flex-col md:pr-4 border-r border-gray-200">
            <div className="mb-8">
              <JoinSubscriptionSummaryView
                title={summaryTitle}
                isUnlockExpiredPost={isUnlockExpiredPost}
                currency={currency}
                price={price}
              />
            </div>

            {/*  plan summary */}
            <div className="mb-2">
              <JoinSubscriptionPaymentView
                isUnlockExpiredPost={isUnlockExpiredPost}
                postId={postId}
                subscriptionPlanId={_id}
                onCancel={onClickBackToMain}
                price={price}
              />
            </div>
          </div>
        </Grid>

        <Hidden smDown>
          <Grid item xs={12} md={4}>
            <div className="w-full px-4 flex item-center justify-center">
              <SubscriptionPlanCard
                hideButton
                canUnlockPost={canUnlockPost}
                subscriptionPlan={subscriptionPlan}
                isUnlockExpiredContent={isUnlockExpiredPost}
              />
            </div>
          </Grid>
        </Hidden>
      </Grid>
    );
  };
